import React, { useEffect, useRef, useState } from 'react';
import api, { audioSourceUrl } from '../utils/api';

/*
 * پخش یادداشت صوتی.
 *
 * فایل پشت یک ویوی دارای احراز هویت است، پس نمی‌شود مستقیم در src تگ audio
 * گذاشت — مرورگر هدر Authorization را نمی‌فرستد. به‌جایش با axios می‌گیریم و
 * به object URL تبدیل می‌کنیم.
 */

export default function AudioNote({ url, seconds }) {
  const [objectUrl, setObjectUrl] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const createdRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    if (!url) return undefined;

    setLoading(true);
    api
      .get(audioSourceUrl(url), { responseType: 'blob', baseURL: '' })
      .then(({ data }) => {
        if (cancelled) return;
        const objUrl = URL.createObjectURL(data);
        createdRef.current = objUrl;
        setObjectUrl(objUrl);
      })
      .catch(() => !cancelled && setError('پخش یادداشت صوتی ممکن نشد.'))
      .finally(() => !cancelled && setLoading(false));

    return () => {
      cancelled = true;
      if (createdRef.current) {
        URL.revokeObjectURL(createdRef.current);
        createdRef.current = null;
      }
    };
  }, [url]);

  if (!url) return null;
  if (loading) return <p className="muted">در حال بارگذاری یادداشت صوتی…</p>;
  if (error) return <p className="field__error">{error}</p>;

  return (
    <div className="audio-note">
      <span aria-hidden="true">🎧</span>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <audio controls src={objectUrl} className="audio-note__player" />
      {seconds ? <span className="num muted">{seconds}s</span> : null}
    </div>
  );
}
